module.exports = __webpack_public_path__ + "img/banner.cf2c839f.png";